const actionTypePrefix = "/config/";

import {
  IUploadCollaborativeShareUserActionPayload,
  IUploadCollaborativeShareUserAction,
  IGetRegistrationPayload,
  IGetRegisteredData,
  IRegistrationData,
  IAddRegistrationPayload,
  IGetCollaborativeSharePermissionActionPayload,
  IGetCollaborativeSharePermissionAction,
  IGetCollaborativeFormUserActionPayload,
  IGetCollaborativeFormUserAction,
} from "./interface";

export const configAction = {
  ADD_REGISTRATION_DATA: `${actionTypePrefix}ADD_REGISTRATION_DATA`,
  ADD_REGISTRATION_DATA_SUCCESS: `${actionTypePrefix}ADD_REGISTRATION_DATA_SUCCESS`,
  ADD_REGISTRATION_DATA_FAILURE: `${actionTypePrefix}ADD_REGISTRATION_DATA_FAILURE`,

  UPLOAD_COLLABORATIVE_SHARE: `${actionTypePrefix}UPLOAD_COLLABORATIVE_SHARE`,

  GET_COLLABORATIVE_PERMISSION_LIST: `${actionTypePrefix}GET_COLLABORATIVE_PERMISSION_LIST`,
  GET_COLLABORATIVE_FORM_USER_LIST: `${actionTypePrefix}GET_COLLABORATIVE_FORM_USER_LIST`,

  GET_REGISTRATION_DATA: `${actionTypePrefix}GET_REGISTRATION_DATA`,
};
export const addRegisterData = (
  registrationData: IRegistrationData
): IAddRegistrationPayload => {
  return {
    type: configAction.ADD_REGISTRATION_DATA,
    payload: registrationData,
  };
};
export const addRegistrationDataSuccess = () => {
  return {
    type: configAction.ADD_REGISTRATION_DATA_SUCCESS,
  };
};
export const addRegistrationDataFailure = (error: string) => {
  return {
    type: configAction.ADD_REGISTRATION_DATA_FAILURE,
    payload: error,
  };
};
export const getRegistrationData = (
  registrationData: IGetRegisteredData
): IGetRegistrationPayload => {
  return {
    type: configAction.GET_REGISTRATION_DATA,
    payload: registrationData,
  };
};

export const uploadCollaborativeShareUserAction = (
  payloadData: IUploadCollaborativeShareUserActionPayload
): IUploadCollaborativeShareUserAction => {
  return {
    type: configAction.UPLOAD_COLLABORATIVE_SHARE,
    payload: payloadData
  };
};

export const getCollaborativeSharePermissionAction = (
  payloadData: IGetCollaborativeSharePermissionActionPayload
): IGetCollaborativeSharePermissionAction => {
  return {
    type: configAction.GET_COLLABORATIVE_PERMISSION_LIST,
    payload: payloadData
  };
};

export const getCollaborativeFormUserAction = (
  payloadFormData: IGetCollaborativeFormUserActionPayload
): IGetCollaborativeFormUserAction => {
  return {
    type: configAction.GET_COLLABORATIVE_FORM_USER_LIST,
    payload: payloadFormData
  };
};